/**
 * @file Manages styles for BlogListTile.
 */
import { css } from 'styled-components';
export default css([""]);